import { useEffect, useState } from 'react';
import { Card, Grid, Typography, Tabs, Tab, Box, ToggleButtonGroup, ToggleButton, CircularProgress } from "@mui/material";
import axios from "axios"
import { useOktaAuth } from "@okta/okta-react";
import { useObservabilityDashboardAPI } from "../as2-onboarding-component/hooks/useClient";

const DashboardComponent = () => {
    const [dashboards, setDashboards] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [timeRange, setTimeRange] = useState('1d');
    const [loading, setLoading] = useState(true);

    const handleTabChange = (event, newValue) => setActiveTab(newValue);
    const handleTimeRangeChange = (event, newTimeRange) => {
        if (newTimeRange !== null) setTimeRange(newTimeRange);
    };
    const { oktaAuth } = useOktaAuth();
    const dashboardsClient = useObservabilityDashboardAPI(oktaAuth.getAccessToken());

    const fetchDashboards = async () => {
        try {
            const response = await dashboardsClient.get(
                `/getDashboards?timeRange=${timeRange}`
            );
            setDashboards(response.data.dashboards.map((dashboard) => ({
                id: dashboard.id,
                widget: `data:image/png;base64,${dashboard.widget}`,
                category: dashboard.category,
            })));
        } catch (error) {
            console.error('Error fetching dashboards:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDashboards();
    }, [timeRange]);

    return (
        <>
            <Typography gutterBottom variant="h1" component="h1">
                <span className='cardcontain'>EDI Observability Dashboard</span>
            </Typography>
            <Card className="p-4">
                <Grid container justifyContent="space-between" alignItems="center" padding={2}>
                    {activeTab === 1 && (
                        <ToggleButtonGroup value={timeRange} exclusive onChange={handleTimeRangeChange} size="small" disabled={loading}>
                            <ToggleButton value="1d">1 Day</ToggleButton>
                            <ToggleButton value="2d">2 Days</ToggleButton>
                            <ToggleButton value="7d">7 Days</ToggleButton>
                            <ToggleButton value="30d">30 Days</ToggleButton>
                        </ToggleButtonGroup>
                    )}
                </Grid>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', paddingX: 2 }}>
                    <Tabs value={activeTab} onChange={handleTabChange}>
                        <Tab label="Nodes" />
                        <Tab label="Bp Monitoring" />
                        <Tab label="Queues" />
                        <Tab label="Web EDI" />
                        <Tab label="Oracle" />
                    </Tabs>
                </Box>
                {[
                    ['nodes', 'Nodes'],
                    ['bp-monitoring', 'Bp Monitoring'],
                    ['queues', 'Queues'],
                    ['webedi', 'Web EDI'],
                    ['oracle', 'Oracle'],
                ].map(([category, label], index) => activeTab === index && (
                    <Box key={category} padding={3}>
                        {loading ? (
                            <Box display="flex" justifyContent="center" alignItems="center" minHeight={400}>
                                <CircularProgress size={60} />
                            </Box>
                        ) : (
                            <Grid container alignItems="center" spacing={3}>
                                {dashboards.filter((dashboard) => dashboard.category === category).map((dashboard) => (
                                    <Grid item xs={12} sm={6} key={dashboard.id}>
                                        <img src={dashboard.widget} alt={`${label} widget`} style={{ width: '100%', height: 'auto' }} />
                                    </Grid>
                                ))}
                            </Grid>
                        )}
                    </Box>
                ))}
            </Card>
        </>
    )
}

export default DashboardComponent;
